import { useCreate } from '../../../../../../../api/react-query';

export function useCreateNoticePeriodAutomationConfig() {
  const {
    mutateAsync: createNoticePeriodAutomationConfig,
    isLoading: isCreating,
    error,
  } = useCreate({
    url: 'config/noticePeriod/auto',
  });

  return {
    createNoticePeriodAutomationConfig,
    isCreating,
    error,
  };
}
